"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddCard", {
  enumerable: true,
  get: function get() {
    return _addCardIcon.default;
  }
});
Object.defineProperty(exports, "Any", {
  enumerable: true,
  get: function get() {
    return _anyIcon.default;
  }
});
Object.defineProperty(exports, "Back", {
  enumerable: true,
  get: function get() {
    return _backIcon.default;
  }
});
exports.BankLogosInv = exports.BankLogos = void 0;
Object.defineProperty(exports, "Bog", {
  enumerable: true,
  get: function get() {
    return _bogIcon.default;
  }
});
Object.defineProperty(exports, "BogInv", {
  enumerable: true,
  get: function get() {
    return _bogIconInverse.default;
  }
});
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function get() {
    return _cardIcon.default;
  }
});
exports.DepositLogos = exports.CashDeskLogos = void 0;
Object.defineProperty(exports, "EMoney", {
  enumerable: true,
  get: function get() {
    return _emoneyIcon.default;
  }
});
Object.defineProperty(exports, "EPay", {
  enumerable: true,
  get: function get() {
    return _ePayIcon.default;
  }
});
Object.defineProperty(exports, "Fail", {
  enumerable: true,
  get: function get() {
    return _failIcon.default;
  }
});
exports.IdLogos = void 0;
Object.defineProperty(exports, "Info", {
  enumerable: true,
  get: function get() {
    return _infoIcon.default;
  }
});
Object.defineProperty(exports, "LEADER_CARD", {
  enumerable: true,
  get: function get() {
    return _leaderCard.default;
  }
});
Object.defineProperty(exports, "Lb", {
  enumerable: true,
  get: function get() {
    return _lbIcon.default;
  }
});
Object.defineProperty(exports, "LeaderPay", {
  enumerable: true,
  get: function get() {
    return _leaderPayIcon.default;
  }
});
Object.defineProperty(exports, "Lib", {
  enumerable: true,
  get: function get() {
    return _libIcon.default;
  }
});
Object.defineProperty(exports, "Map", {
  enumerable: true,
  get: function get() {
    return _mapIcon.default;
  }
});
Object.defineProperty(exports, "NoAddCard", {
  enumerable: true,
  get: function get() {
    return _noAddCardIcon.default;
  }
});
Object.defineProperty(exports, "Oppa", {
  enumerable: true,
  get: function get() {
    return _oppaIcon.default;
  }
});
Object.defineProperty(exports, "Resend", {
  enumerable: true,
  get: function get() {
    return _resendIcon.default;
  }
});
exports.Results = void 0;
Object.defineProperty(exports, "Success", {
  enumerable: true,
  get: function get() {
    return _successIcon.default;
  }
});
Object.defineProperty(exports, "Tbc", {
  enumerable: true,
  get: function get() {
    return _tbcIcon.default;
  }
});
Object.defineProperty(exports, "TbcInv", {
  enumerable: true,
  get: function get() {
    return _tbcIconInverse.default;
  }
});
Object.defineProperty(exports, "TbcPay", {
  enumerable: true,
  get: function get() {
    return _tbcPayIcon.default;
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _videoIcon.default;
  }
});
exports.WalletLogos = void 0;
Object.defineProperty(exports, "WebMoney", {
  enumerable: true,
  get: function get() {
    return _webMoneyIcon.default;
  }
});
var _bogIcon = _interopRequireDefault(require("./bog.icon.svg"));
var _bogIconInverse = _interopRequireDefault(require("./bog.icon.inverse.svg"));
var _tbcIcon = _interopRequireDefault(require("./tbc.icon.svg"));
var _tbcIconInverse = _interopRequireDefault(require("./tbc.icon.inverse.svg"));
var _libIcon = _interopRequireDefault(require("./lib.icon.svg"));
var _anyIcon = _interopRequireDefault(require("./any.icon.png"));
var _emoneyIcon = _interopRequireDefault(require("./emoney.icon.svg"));
var _ePayIcon = _interopRequireDefault(require("./ePay.icon.svg"));
var _tbcPayIcon = _interopRequireDefault(require("./tbcPay.icon.svg"));
var _oppaIcon = _interopRequireDefault(require("./oppa.icon.svg"));
var _webMoneyIcon = _interopRequireDefault(require("./webMoney.icon.svg"));
var _lbIcon = _interopRequireDefault(require("./lb.icon.svg"));
var _successIcon = _interopRequireDefault(require("./success.icon.svg"));
var _failIcon = _interopRequireDefault(require("./fail.icon.svg"));
var _addCardIcon = _interopRequireDefault(require("./addCard.icon.svg"));
var _noAddCardIcon = _interopRequireDefault(require("./noAddCard.icon.svg"));
var _infoIcon = _interopRequireDefault(require("./info.icon.svg"));
var _cardIcon = _interopRequireDefault(require("./card.icon.svg"));
var _mapIcon = _interopRequireDefault(require("./map.icon.svg"));
var _videoIcon = _interopRequireDefault(require("./video.icon.svg"));
var _backIcon = _interopRequireDefault(require("./back.icon.svg"));
var _resendIcon = _interopRequireDefault(require("./resend.icon.svg"));
var _leaderPayIcon = _interopRequireDefault(require("./leader.pay.icon.jpg"));
var _leaderCard = _interopRequireDefault(require("./leaderCard.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BankLogos = {
  "BOG": _bogIcon.default,
  "TBC": _tbcIcon.default,
  "LIB": _libIcon.default,
  "ANY": _anyIcon.default,
  "LEADER_CARD": _leaderCard.default
};
exports.BankLogos = BankLogos;
var BankLogosInv = {
  "BOG": _bogIconInverse.default,
  "TBC": _tbcIconInverse.default,
  "LIB": _libIcon.default,
  "ANY": _anyIcon.default,
  "LEADER_CARD": _leaderCard.default
};
exports.BankLogosInv = BankLogosInv;
var WalletLogos = {
  EMoney: _emoneyIcon.default,
  TbcPay: _tbcPayIcon.default,
  Oppa: _oppaIcon.default,
  WebMoney: _webMoneyIcon.default,
  LeaderPay: _leaderPayIcon.default,
  Lb: _lbIcon.default
};
exports.WalletLogos = WalletLogos;
var DepositLogos = {
  EPay: _ePayIcon.default,
  TbcPay: _tbcPayIcon.default,
  Oppa: _oppaIcon.default,
  Lb: _lbIcon.default
};
exports.DepositLogos = DepositLogos;
var CashDeskLogos = {
  Lb: _lbIcon.default,
  LeaderPay: _leaderPayIcon.default,
  Tbc: _tbcIcon.default
};
exports.CashDeskLogos = CashDeskLogos;
var IdLogos = {
  Bog: _bogIcon.default,
  Lib: _libIcon.default
};
exports.IdLogos = IdLogos;
var Results = {
  Success: _successIcon.default,
  Fail: _failIcon.default
};
exports.Results = Results;